import {
    LOAD_REPORT,
    DOWNLOAD_PRODUCT_REPORT_ERROR
} from "../../../actions/types";

const INITIAL_STATE = {
    totalOrders: -1,
    totalOrdersAmount: -1,
    orderTypes: {
        ordersByOrderType: {
            count: -1,
            totalAmount: -1
        },
        ordersByPayment: {
            count: -1,
            totalAmount: -1
        },
        ordersByStatus: {
            count: -1,
            totalAmount: -1
        }
    },
    downloadProductReportErrMsg: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_REPORT:
            return {
                ...state,
                totalOrders: action.payload.totalOrders,
                totalOrdersAmount: action.payload.totalOrdersAmount,
                orderTypes: {
                    ordersByOrderType: action.payload.ordersByOrderType,
                    ordersByPayment: action.payload.ordersByPayment,
                    ordersByStatus: action.payload.ordersByStatus
                }
            };
        case DOWNLOAD_PRODUCT_REPORT_ERROR:
            return {
                ...state,
                downloadProductReportErrMsg: action.payload
            };
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/restaurants/reports/ReportsReducer.js